<ng-container *transloco="let t">
  <div class="nscp-invite-manager-step__form">
    <div class="nscp-invite-manager-step__row nscp-invite-manager-step__row--split">
      <sds-form-field>
        <sds-label>{{ t('memberManagement.member.firstNameLabel') }}</sds-label>
        <input sds-input [formField]="inputForm.firstName" id="inviteFirstName" />
        @if (firstNameErrorMessage(); as message) {
          <sds-error>{{ message }}</sds-error>
        }
      </sds-form-field>

      <sds-form-field>
        <sds-label>{{ t('memberManagement.member.lastNameLabel') }}</sds-label>
        <input sds-input [formField]="inputForm.lastName" id="inviteLastName" />
        @if (lastNameErrorMessage(); as message) {
          <sds-error>{{ message }}</sds-error>
        }
      </sds-form-field>
    </div>

    <div class="nscp-invite-manager-step__row nscp-invite-manager-step__row--half">
      <sds-form-field>
        <sds-label>{{ t('memberManagement.member.emailAddressLabel') }}</sds-label>
        <input sds-input type="email" [formField]="inputForm.emailAddress" id="inviteEmailAddress" />
        @if (emailErrorMessage(); as message) {
          <sds-error>{{ message }}</sds-error>
        }
      </sds-form-field>
    </div>
  </div>

  <ng-template #errorCannotCreateUser let-close="close">
    <sds-dialog [closeOnOverlayClick]="false">
      <sds-dialog-header [heading]="t('memberManagement.invite.msg.cannotCreateUser.heading')" [showCloseButton]="false"></sds-dialog-header>
      <p class="nscp-invite-manager-step__dialog-message">
        {{
          t('memberManagement.invite.msg.cannotCreateUser.details', {
            firstName: inputForm.firstName().value(),
            lastName: inputForm.lastName().value(),
          })
        }}
      </p>
      <sds-dialog-footer>
        <button sds-button variant="primary" (click)="close()" metricId="members.invite.close-dialog">
          {{ t('memberManagement.invite.msg.cannotCreateUserWithEmail.buttonAction') }}
        </button>
      </sds-dialog-footer>
    </sds-dialog>
  </ng-template>

  <ng-template #errorCannotCreateExistingOrganizationMember let-close="close">
    <sds-dialog [closeOnOverlayClick]="false" maxWidth="360px">
      <sds-dialog-header [heading]="t('memberManagement.invite.msg.cannotCreateUserWithEmail.heading')" [showCloseButton]="false"></sds-dialog-header>
      <p class="nscp-invite-manager-step__dialog-message">
        {{ t('memberManagement.invite.msg.cannotCreateUserWithEmail.details', { emailAddress: inputForm.emailAddress().value() }) }}
        <br /><br />
        {{ t('memberManagement.invite.msg.cannotCreateUserWithEmail.suggestion') }}
      </p>
      <sds-dialog-footer>
        <button sds-button variant="primary" (click)="close()" metricId="members.invite.close-dialog">
          {{ t('memberManagement.invite.msg.cannotCreateUserWithEmail.buttonAction') }}
        </button>
      </sds-dialog-footer>
    </sds-dialog>
  </ng-template>
</ng-container>
